import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PreRegistrationService extends BaseService {
  override baseUrl = `${environment.apiUrl}/users/pre-inscription`;
}
